/**
 * Created by BETALOS on 14/07/2016.
 */
(function () {

    'use strict';

    const angular = require('angular');

    const visitService = require("./services/visitService");

    const visitProcedures = require("./components/visit-procedures");
    const payablePayments = require("./components/payable-payments");

    const VisitListCtrl = require("./controllers/VisitListCtrl");
    const VisitMainCtrl = require("./controllers/VisitMainCtrl");

    angular
        .module("medinet")

        .service('visitService', visitService)

        .component('mnVisitProcedures', visitProcedures)
        .component('mnPayablePayments', payablePayments)

        .controller('VisitMainCtrl', VisitMainCtrl)

        .controller('VisitListCtrl', VisitListCtrl);


})();